module.exports = __webpack_public_path__ + "img/4.d0bf2264.png";